import Login from "./pages/Login";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import "simplebar-react/dist/simplebar.min.css";
import "./style.scss";
import Home from "./pages/Home";
import { useEffect, useState } from "react";
import spinnerSvc from "./services/spinner-service";
import { ToastContainer } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import LoadingIndicator from "./components/layouts/Loader";
import { login, loginSelector, setUser, userSelector } from "./redux/authSlice";
import Dashboard from "./pages/admin/Dashboard";
import Survey from "./pages/admin/Survey";
import Sidebar from "./components/layouts/Sidebar";
import SurveyDetail from "./pages/admin/SurveyDetail";
import ClientsHome from "./pages/admin/ClientsHome";
import Clients from "./pages/admin/Clients";
import HeaderMain from "./components/layouts/HeaderMain";
import { api } from "./services/api-service";
import { addFields } from "./redux/fieldsSlice";
import { addLookup } from "./redux/lookupSlice";
import { setSurvey } from "./redux/surveySlice";
import User from "./pages/admin/User";
import Templates from "./pages/admin/Templates";
import Lookup from "./pages/admin/Lookup";
import ForgetPassword from "./pages/ForgetPassword";
import { setSurveyors } from "./redux/userSlice";
import Toaster from "./components/baseui/Toaster";
import ErrorToast from "./components/baseui/ErrorToast";

function App() {
  let clientInput = "";
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isLoggedIn = localStorage.getItem("loggedIn") === "true";
  const user = JSON.parse(localStorage.getItem("user"));
  const userLogin = useSelector(loginSelector);
  const currentroute = window.location.pathname;
  const [offline, setOffline] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loggedIn, setLoggedIn] = useState(isLoggedIn);

  useEffect(() => {
    setLoggedIn(isLoggedIn || userLogin);
  }, [isLoggedIn, userLogin]);

  useEffect(() => {
    const validateLoggedInStatus = async () => {
      const token = localStorage.getItem("idToken");
      if (token) {
        setLoggedIn(true);
        dispatch(login());
        dispatch(setUser(JSON.parse(localStorage.getItem("user"))));
        navigate({ currentroute });
      } else {
        setLoggedIn(false);
      }
    };
    validateLoggedInStatus();

    const subscription = spinnerSvc.requestInProgress.subscribe((isLoading) =>
      setIsLoading(isLoading)
    );

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  useEffect(() => {
    // sendNotification();
    if (loggedIn) {
      getFields();
    }
  }, [loggedIn]);

  // const sendNotification = () => {
  //   const connectionString =
  //     "Endpoint=sb://a360-rncs.servicebus.windows.net/;SharedAccessKeyName=DefaultFullSharedAccessSignature;SharedAccessKey=JGoFjeo/Eas6B8EkQLLYB15xOXO+IteoqZ3BUw5alxc=";
  //   const hubName = "pwa";

  //   const client = new NotificationHubsClient(connectionString, hubName);

  //   const notification = {
  //     title: "My Notification",
  //     body: "Hello, world!",
  //   };

  //   const tags = ["tag1", "tag2"];
  //   client.updateInstallation(user.id, { tags: tags });

  //   client
  //     .sendNotification({
  //       body: "My Notification",
  //       contentType: "application/json;charset=utf-8",
  //       platform: "browser",
  //     })
  //     .then((response) => {
  //       console.log("Notification sent: ", response);
  //     })
  //     .catch((error) => {
  //       console.error("Error sending notification: ", error);
  //     });
  // };

  // const getData = () => {
  //   fetch("https://dummyjson.com/products").then((res) => {
  //     res.json().then((ans) => console.log(ans));
  //   });
  // };

  const getFields = async () => {
    const response = await api.get("get-fields?type=admin");
    let adminFields = [];
    if (response && response.ok) {
      adminFields = response.data.data.map((field) => {
        return {
          ...field,
          handleChange: (val) => handleChange(field.name, val),
          handleInputChange: (val) => handleInputChange(field.name, val),
          fetchData: () => field.name === "clientName" && getAllClients(),
          options: field.type === "select" ? getLookup(field.name) : undefined,
        };
      });
      dispatch(addFields(adminFields));
    }
  };

  const getLookup = async (field) => {
    if (field === "ifrsCategorization" || field === "valuationMethod") {
      const response = await api.get(`lookup?type=${field}`);
      if (response && response.ok) {
        const data = response.data.data.map((data) => {
          return { ...data, label: data.id, value: data.id };
        });
        dispatch(addLookup({ type: field, value: data }));
      }
    }
    if (field === "surveyorId") {
      const response = await api.get(`get-surveyors?pageSize=100`);
      if (response && response.ok) {
        dispatch(
          setSurveyors({
            ...response.data.data,
            data: response.data.data.data.map((res) => {
              return {
                ...res,
                label: res.firstName + " " + res.lastName,
                value: res.id,
              };
            }),
          })
        );
      }
    }
  };

  const handleInputChange = (field, value) => {
    clientInput = value;
  };

  const handleChange = (field, value) => {
    if (field === "surveyorId") {
      dispatch(
        setSurvey({ field: "surveyorId", value: value ? value?.id : "" })
      );
      dispatch(
        setSurvey({
          field: "surveyorName",
          value: value ? value?.firstName + " " + value?.lastName : "",
        })
      );
      return;
    }
    dispatch(setSurvey({ field, value }));
  };

  const getAllClients = async () => {
    const response = await api.get(`get-clients?searchText=${clientInput}`);
    if (response && response.ok) {
      return { options: response.data.data.data };
    } else {
      return { options: [] };
    }
  };

  return (
    <>
      <ToastContainer hideProgressBar={true} />
      <Toaster />
      <ErrorToast />
      {isLoading && <LoadingIndicator />}
      {!loggedIn ? (
        <Routes>
          <Route path="*" element={<Navigate to="/" />}></Route>
          <Route
            exact
            path="/forget-password"
            element={<ForgetPassword />}
          ></Route>
          <Route exact path="/" element={<Login />}></Route>
        </Routes>
      ) : user?.role === "surveyor" ? (
        <Routes>
          <Route path="*" element={<Navigate to={"/home"} />}></Route>
          <Route path="/" element={<Navigate to={"/home"} />}></Route>
          <Route path="/home" element={<Home />}></Route>
        </Routes>
      ) : (
        <>
          <Sidebar />
          <HeaderMain />
          <Routes>
            <Route
              exact
              path="/"
              element={<Navigate to="/dashboard" />}
            ></Route>
            <Route path="/dashboard" element={<Dashboard />}></Route>
            <Route exact path="/surveys" element={<Survey />}></Route>
            <Route path="/survey-detail/:id" element={<SurveyDetail />}></Route>
            <Route path="/clients-overview" element={<ClientsHome />}></Route>
            <Route path="/clients" element={<Clients />}></Route>
            <Route path="/users" element={<User />}></Route>
            <Route path="/lookup" element={<Lookup />}></Route>
            <Route path="/templates" element={<Templates />}></Route>
            <Route path="/templates/:id" element={<Templates />}></Route>
            <Route path="*" element={<Navigate to="/dashboard" />} />
          </Routes>
        </>
      )}
    </>
  );
}

export default App;
